import { NotificationsLoader } from '@shared/components';
import store from '@store/index';
import { ActionCreator } from './models/interfaces';

// TODO: try to make decorator without getter
export function StoredRequest(...actions: [ActionCreator, ...ActionCreator[]]) {
  return (
    _: unknown,
    memberName: string,
    propertyDescriptor: PropertyDescriptor,
  ) => {
    return {
      get() {
        const { dispatch } = store;

        const wrapperFn = async (...args: any[]) => {
          const lastArg = args[args.length - 1];
          const hasOptions =
            lastArg && typeof lastArg === 'object' && 'silent' in lastArg;
          const userOptions = hasOptions ? lastArg : {};
          const apiArgs = hasOptions ? args.slice(0, -1) : args;

          const silent = userOptions.silent || false;
          let notification;

          if (!silent) {
            notification = new NotificationsLoader({
              message: 'Loading',
              description: 'Please wait',
            });
          }

          actions.forEach(({ start }: ActionCreator) => dispatch(start()));

          try {
            const res = await propertyDescriptor.value.apply(this, apiArgs);

            actions.forEach(({ done }: ActionCreator) => dispatch(done(res)));
            notification?.close();

            return res;
          } catch (error) {
            console.error(error);
            actions.forEach(({ fail }: ActionCreator) => dispatch(fail()));
            notification?.close();
            throw error;
          }
        };

        Object.defineProperty(this, memberName, {
          value: wrapperFn,
          configurable: true,
          writable: true,
        });

        return wrapperFn;
      },
    };
  };
}
